<template>
	<div>
		<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.message }}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false"> Close </v-btn>
		</v-snackbar>

		<!-- <v-layout row wrap>
			<v-flex xl3 lg4 md6 sm6 xs12 class="pr-3">
				<tag-selector :options="tagList"
							:selectedOptions="selectedTags"
							:isMatchAll="matchAllTags"
							placeholder="Enter Tag"
							@on-selected-tags-change="updateSelectedTags"
							@on-match-all-tags-change="updateMatchAllTags"
							@on-leave="onLeaveTagSelector"></tag-selector>
			</v-flex>
		</v-layout> -->

		<div id="tree" ref="tree"></div>

		<org-chart-node-editor 
		v-if="showNodeEditor" 
		:is-saving="isSavingNode" 
		:node="nodeToEdit" 
		:dialog="showNodeEditor"
		:loggedInEmployee="loggedInEmployee"
		@onClose="hideNodeEditor" 
		@onSubmit="onSubmitNodeEditor" />

		<v-footer color="" app height="55">
			<v-spacer></v-spacer>
			<v-btn v-if="history.length > 0 && !isSaving" @click="undo"><v-icon class="mr-2">undo</v-icon>Undo Move</v-btn>
			<v-btn v-if="isDirty" class="action-btn" :loading="isSaving" :disabled="isSaving" @click="saveChanges">
				Save Changes
				<v-icon right>send</v-icon>
				<span slot="loader">Saving...</span>
			</v-btn>
		</v-footer>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import OrgChart from '@/vendor/balkangraph/orgchart.js';
	import OrgChartNodeEditor from '@/components/orgChart/OrgChartNodeEditor';
	import TagSelector from '@/components/tags/TagSelector';

	var editForm = function (vue) {
		this._vue = vue;
	};

	editForm.prototype.init = function (obj) {};

	editForm.prototype.show = function (node) {
		this._vue.nodeToEdit = this._vue.orgChart.find((x) => x.id === node);
		this._vue.showNodeEditor = true;
	};

	editForm.prototype.hide = function (showldUpdateTheNode) {};

	export default {
		components: {
			OrgChartNodeEditor,
			TagSelector
		},
		data() {
			return {
				chart: null,
				reportsToArray: [],
				reportsToArrayOriginal: [],
				history: [],
				movingNode: {},
				isSaving: false,
				isSavingNode: false,
				showNodeEditor: false,
				nodeToEdit: undefined,
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				},
				search: '',
				selectedTags: [],
				matchAllTags: false
			};
		},
		// watch: {
		// 	orgChartFiltered() {
		// 		this.buildChart(this.$refs.tree, this.orgChartFiltered);
		// 	}
		// },
		mounted() {
			OrgChart.templates.ana.exportMenuButton =
				'<div style="position:absolute;right:{p}px;top:{p}px; width:40px;height:50px;cursor:pointer" control-export-menu=""><i aria-hidden="true" class="v-icon material-icons" style="font-size: 32px; color: rgb(117, 117, 117);">menu</i></div>';

			OrgChart.MIXED_LAYOUT_ALL_NODES = false;

			this.buildChart(this.$refs.tree, this.orgChart);
		},
		computed: {
			...mapGetters({
				orgChart: 'employees/orgChart',
				loggedInTenant: 'loggedInTenant',
				loggedInEmployee: 'loggedInEmployee',
				tagList: 'tags/employeeTagList'
			}),
			filteredEmployeeIds() {
				const filterOptions = {
					search: this.search,
					tags: this.selectedTags,
					matchAllTags: this.matchAllTags
				};
				return this.$_getFilteredEmployeeIds(this.loggedInEmployee, filterOptions);
			},
			orgChartFiltered() {
				return this.orgChart.filter(x => this.filteredEmployeeIds.includes(x.id));
			},
			isDirty() {
				return this.updates.length > 0;
			},
			updates() {
				const updates = [];
				this.reportsToArray.forEach((x) => {
					const original = this.reportsToArrayOriginal.find((y) => y.employeeId === x.employeeId);
					if (original && original.reportsToId !== x.reportsToId) updates.push({ ...x });
				});
				return updates;
			},
			rootNodes() {
				return this.orgChart.filter(x => x.pid == null);
			}
		},
		methods: {
			buildChart(domEl, x) {
				const self = this;
				this.chart = new OrgChart(domEl, {
					template: 'ana',
					nodes: x,
					nodeBinding: {
						field_0: 'name',
						field_1: 'note',
						img_0: 'img'
					},
					collapse: {
						level: 2,
						allChildren: true
					},
					nodeMouseClick: OrgChart.action.none,
					mouseScrool: OrgChart.action.scroll,
					editUI: new editForm(this),
					scaleInitial: self.rootNodes.length >= 3 ? OrgChart.match.width : 1,
					layout: OrgChart.tree,
					menu: {
						export_pdf: {
							text: 'Export to PDF',
							icon: OrgChart.icon.pdf(24, 24),
							onClick: (nodeId) => {
								OrgChart.pdfPrevUI.show(self.chart, {
									filename: `${self.loggedInTenant.name} - Org Chart.pdf`,
									format: 'A4',
									expandChildren: true,
									nodeId: nodeId,
									header: `${self.loggedInTenant.name} - Org Chart`,
									footer: 'Page {current-page} of {total-pages}',
									padding: 30,
									landscape: true
								});
							}
						}
					},
					nodeMenu: this.buildNodeMenu(),
					sticky: false,
					enableDragDrop: this.loggedInEmployee.isAdmin,
					toolbar: {
						zoom: true,
						fit: true,
						expandAll: true,
						layout: true
					},
					tags: {
						group: {
							template: 'group'
						},
						manager: {
							min: true,
							template: 'ula'
						},
						employee: {
							template: 'ula'
						},
						inactive: {
							template: 'ula'
						}
					}
				});

				this.buildReportsToArray();

				this.chart.on('drag', (sender, draggedNodeId) => {
					self.movingNode = { ...self.chart.get(draggedNodeId) };
				});
				this.chart.on('drop', (sender, draggedNodeId, droppedNodeId) => {
					const isInvalidDrop = (node) => {
						if (node.pid === droppedNodeId) return true;
						if (node.children.length === 0) return false;
						return node.children.some((child) => {
							if (child.id === droppedNodeId) return true;
							else return isInvalidDrop(child);
						});
					};

					const node = self.chart.nodes[draggedNodeId];
					if (!isInvalidDrop(node)) {
						const index = self.reportsToArray.findIndex((x) => x.employeeId === draggedNodeId);
						if (index > -1) {
							const updated = { ...self.reportsToArray[index], reportsToId: droppedNodeId };
							self.reportsToArray.splice(index, 1, updated);
						}
						self.history.push(self.movingNode);
					}
				});

				this.chart.on('exportstart', function (sender, args) {
					args.styles += '<style>.node{font-family: "Avenir", Helvetica, Arial, sans-serif;}.inactive>line{stroke: #f44336;}.inactive>rect{fill: #ffebee;}</style>';
				});
			},
			buildReportsToArray() {
				if (this.chart && this.chart.nodes) {
					const result = [];
					for (const [key, value] of Object.entries(this.chart.nodes)) {
						result.push({
							employeeId: key,
							reportsToId: value.pid
						});
					}

					this.reportsToArray = result;
					this.reportsToArrayOriginal = [...result];
				}
			},
			hideNodeEditor() {
				this.showNodeEditor = false;
				this.nodeToEdit = undefined;
			},
			onSubmitNodeEditor(node) {
				this.isSavingNode = true;
				this.$store.dispatch('employees/updateOrgChartNode', node).then(
					(response) => {
						this.isSavingNode = false;
						this.showNodeEditor = false;

						// Update chart
						let node = this.orgChart.find((x) => x.id === response.id);
						this.chart.updateNode(node);

						this.showSnackbar('Changes Saved');
					},
					(error) => {
						this.isSavingNode = false;
						this.showSnackbar('Failed to update employee details', true);
					}
				);
			},
			saveChanges() {
				this.isSaving = true;
				this.$store.dispatch('employees/updateOrgChart', this.updates).then(
					(response) => {
						this.isSaving = false;
						this.history = [];
						this.buildReportsToArray();
						this.showSnackbar('Changes Saved');
					},
					(error) => {
						this.isSaving = false;
					}
				);
			},
			undo() {
				if (this.history.length > 0) {
					const node = this.history.pop();

					const index = this.reportsToArray.findIndex((x) => x.employeeId === node.id);
					const updated = { ...this.reportsToArray[index], reportsToId: node.pid };
					this.reportsToArray.splice(index, 1, updated);

					this.chart.updateNode(node);
				}
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			},
			buildNodeMenu() {
				const self = this;

				let result = {
					edit: { text: 'Edit' },
					view: {
						icon: '<i aria-hidden="true" class="v-icon material-icons">person</i>',
						text: 'View Profile',
						onClick: (nodeId) => {
							if (this.$_hasAccessToEmployee(this.loggedInEmployee, nodeId)) {
								this.$router.push({ name: 'employee', params: { id: nodeId } });
							} else {
								alert("You do not have access to view this employee profile");
							}
						}
					},
					export_pdf: {
						text: 'Export to PDF',
						icon: OrgChart.icon.pdf(24, 24, '#7A7A7A'),
						onClick: (nodeId) => {
							const name = self.orgChart.find((x) => x.id === nodeId).name;

							OrgChart.pdfPrevUI.show(self.chart, {
								filename: `${self.loggedInTenant.name} - Org Chart.pdf`,
								format: 'A4',
								expandChildren: true,
								nodeId: nodeId,
								header: `${self.loggedInTenant.name} - ${name}`,
								footer: 'Page {current-page} of {total-pages}',
								padding: 30,
								landscape: true
							});
						}
					}
				};

				return result;
			},
			updateSelectedTags(newSelectedTags) {
				this.selectedTags = newSelectedTags;
			},
			updateMatchAllTags(newMatchAll) {
				this.matchAllTags = newMatchAll;
			},
			onLeaveTagSelector() {
				this.$refs.focusAfterTagSelector.focus();
			},
			updateSearch(val) {
				this.search = val;
			}
		}
	};
</script>

<style lang="scss">
	#tree {
		width: 100%;
		height: calc(100vh - 168px);
	}
	#bg-ppdf-btns {
		button,
		input,
		select {
			border: solid 1px;
		}
		button,
		select {
			cursor: pointer;
		}
		#bg-prev-save {
			background-color: #1976d2 !important;
			color: #fff !important;
		}
		#bg-prev-cancel {
			background-color: #f5f5f5 !important;
		}
	}
	.inactive > line {
		stroke: #f44336;
	}
	.inactive > rect {
		fill: #ffebee;
	}
	.drag-over line {
		stroke: #4caf50;
		stroke-width: 3;
		opacity: 1;
	}
</style>